import { useState } from 'react'
import { Card, Button, Modal, Message, Typography } from '@arco-design/web-react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { generateAccessTokenApi } from '@/api/user'
import SystemTokenModal from './modals/SystemTokenModal'

interface SystemAccessTokenCardProps {
  runSecure: <T>(fn: () => Promise<T>) => Promise<T>
}

export default function SystemAccessTokenCard({ runSecure }: SystemAccessTokenCardProps) {
  const { t } = useTranslation()
  const [token, setToken] = useState('')
  const [modalOpen, setModalOpen] = useState(false)
  const [loading, setLoading] = useState(false)

  const resetToken = () => {
    Modal.confirm({
      title: t('personal.token.resetConfirmTitle'),
      content: t('personal.token.resetConfirmContent'),
      onOk: async () => {
        setLoading(true)
        try {
          const data = await runSecure(() => generateAccessTokenApi())
          const value = typeof data === 'string' ? data : (data as { access_token: string }).access_token
          setToken(value)
          setModalOpen(true)
        } catch (err: unknown) {
          if (err instanceof Error && err.message !== t('用户取消了二次验证')) {
            Message.error(err instanceof Error ? err.message : t('personal.token.generateFailed'))
          }
        } finally {
          setLoading(false)
        }
      },
    })
  }

  return (
    <>
      <Card className="tt-card !rounded-2xl !border-[var(--console-border)]" title={t('personal.token.title')}>
        <Typography.Paragraph className="text-sm text-[var(--console-text-muted)] !mb-3">
          {t('personal.token.desc')}
        </Typography.Paragraph>
        <Link to="/console/api-keys" className="text-sm text-[var(--brand-primary)] hover:underline">
          {t('personal.token.apiKeysLink')} →
        </Link>
        <div className="mt-4">
          <Button type="outline" loading={loading} onClick={resetToken}>
            {t('personal.token.reset')}
          </Button>
        </div>
      </Card>

      <SystemTokenModal visible={modalOpen} token={token} onClose={() => setModalOpen(false)} />
    </>
  )
}
